import Heading from '@/common/shared/heading'
import { Separator } from '@/common/ui/separator'
import { DateRangePicker } from '@/common/components/DateRangePicker'
import DateRangeButtons from '@/common/components/DateRangeButtons'
import { PromotionDetailPlayerData } from '@/modules/dashboard/type'
import { DataTableArrow } from '@/common/ui/table/data-table-arrow'
import { columns } from '../PromotionDetailTable/constants'
import { DataTableSearch } from '@/common/ui/table/data-table-search'
import { DataTableResetFilter } from '@/common/ui/table/data-table-reset-filter'
import NavigateBackButton from '@/common/components/NavigateBackButton'

interface PromotionDetailListingProps {
	data: PromotionDetailPlayerData[]
	isLoading?: boolean
	onSort?: (columnId: string, order: 'asc' | 'desc' | undefined) => void
	total: number
	promotionName?: string
}

export default function PromotionDetailListing({
	data,
	total,
	isLoading,
	onSort,
	promotionName,
}: PromotionDetailListingProps) {
	return (
		<div className="space-y-4">
			<div className="flex items-start justify-between">
				<div className="flex flex-col space-y-4">
					<NavigateBackButton />
					<div className="flex items-center gap-4">
						<Heading
							title={`รายละเอียดโปรโมชั่น${promotionName ? ` - ${promotionName}` : ''}`}
							description="ข้อมูลผู้เล่นที่ใช้โปรโมชั่นนี้"
						/>
					</div>
					<div className="flex items-center gap-2">
						<DataTableSearch placeHolder="ค้นหาเบอร์โทรศัพท์" />
						<DataTableResetFilter />
					</div>
				</div>
				<div className="flex flex-col items-end gap-4">
					<DateRangePicker />
					<DateRangeButtons />
				</div>
			</div>

			<Separator />
			<div className="space-y-4">
				<DataTableArrow
					columns={columns}
					data={data}
					total={total}
					isLoading={isLoading}
					onSort={onSort}
				/>
			</div>
		</div>
	)
}
